module.exports = "/_next/static/images/e8c987fb34b713b77561299d99b4deb2-nubank-shooting-hands-diversity@3x.jpg.webp";